import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { X } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * Responsive demo video modal using Vimeo embed.
 * Uses desktop_vimeo_id (16:9 horizontal) on >=768px viewport, mobile_vimeo_id (9:16 vertical) otherwise.
 */
const DemoVideoModal = ({ onClose }) => {
  const [config, setConfig] = useState(null);
  const [isDesktop, setIsDesktop] = useState(() => window.matchMedia('(min-width: 768px)').matches);
  const [loadError, setLoadError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    axios.get(`${API}/public/config/demo-video`)
      .then(res => { if (!cancelled) setConfig(res.data); })
      .catch(() => { if (!cancelled) setLoadError('Vídeo demo indisponível'); });
    const mq = window.matchMedia('(min-width: 768px)');
    const listener = (e) => setIsDesktop(e.matches);
    mq.addEventListener('change', listener);
    const escClose = (e) => { if (e.key === 'Escape') onClose(); };
    window.addEventListener('keydown', escClose);
    return () => {
      cancelled = true;
      mq.removeEventListener('change', listener);
      window.removeEventListener('keydown', escClose);
    };
  }, [onClose]);

  const videoId = isDesktop ? config?.desktop_vimeo_id : (config?.mobile_vimeo_id || config?.desktop_vimeo_id);
  const vimeoSrc = videoId ? `https://player.vimeo.com/video/${videoId}?autoplay=1&title=0&byline=0&portrait=0&dnt=1` : null;
  const aspectRatio = isDesktop ? '56.25%' : '177.78%'; // 16:9 vs 9:16

  return (
    <div
      className="fixed inset-0 z-[100] bg-black/85 backdrop-blur-sm flex items-center justify-center p-4"
      onClick={onClose}
      data-testid="demo-video-modal"
    >
      <div
        className={`relative bg-black rounded-2xl overflow-hidden shadow-2xl ${
          isDesktop ? 'w-full max-w-5xl' : 'w-full max-w-sm'
        }`}
        onClick={(e) => e.stopPropagation()}
      >
        <button
          onClick={onClose}
          className="absolute top-3 right-3 z-10 w-10 h-10 rounded-full bg-black/60 hover:bg-black/80 text-white flex items-center justify-center transition"
          aria-label="Fechar vídeo"
          data-testid="demo-video-close-btn"
        >
          <X className="w-5 h-5" />
        </button>

        {vimeoSrc ? (
          <div className="relative w-full" style={{ paddingBottom: aspectRatio }}>
            <iframe
              src={vimeoSrc}
              title="IMOCODE Demo"
              className="absolute inset-0 w-full h-full"
              frameBorder="0"
              allow="autoplay; fullscreen; picture-in-picture"
              allowFullScreen
              data-testid="demo-video-iframe"
            />
          </div>
        ) : (
          <div className="p-12 text-center text-white/80" data-testid="demo-video-placeholder">
            <p className="text-lg font-semibold mb-2">
              {loadError || 'Vídeo demo não configurado'}
            </p>
            <p className="text-sm text-white/60">
              O administrador ainda não definiu o vídeo de demonstração.
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default DemoVideoModal;
